import { AptunoButton, Icon } from '@aptuno/aptuno-ui';
import { BigTitle } from '@contexts/Estate/EstateApplication/infrastructure/Components/EstateApplication.styled';
import styled from 'styled-components';

export const ActionsBarRoot = styled.div<{
  bgColor?: string;
  flexDirection?: string;
  border?: string;
  height?: string;
  margin?: string;
}>`
  background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.colors.bgNavbarPrimary)};
  height: ${(props) => (props.height ? props.height : '80px')};
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 794px;
  border-radius: 24px 24px 0 0;
  gap: 8px;
  min-height: 60px;
  display: flex;
  justify-content: space-between;
  padding: 16px;
  align-items: center;
  left: 50%;
  transform: translateX(-50%);

  & button {
    max-width: 500px;
    margin: auto;
  }

  ${(props) => props.margin && `margin: ${props.margin}`};
  ${(props) => props.flexDirection && `flex-direction: ${props.flexDirection}`};
  ${(props) => props.border && `border: ${props.border}`};
`;

export const ActionBarLeftButton = styled(AptunoButton)<{ isMobile?: boolean }>`
  max-width: ${({ isMobile }) => (isMobile ? '128px' : '170px')} !important;
`;

export const ActionBarRightButton = styled(AptunoButton)<{ isMobile?: boolean }>`
  ${({ isMobile }) => !isMobile && 'max-width: 100%'} !important;
`;

export const InitIdentityValidationScreenRoot = styled.div`
  height: 100%;
  width: 100%;
`;

export const InitIdentityValidationScreenContent = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  margin: 16px;
  margin-top: 32px;
  margin-bottom: 86px;
  gap: 8px;
  ${({ isMobile }) =>
    !isMobile &&
    `
      margin-top: 88px;
      height: 100%;
    `};
`;

export const HeaderSection = styled.div<{
  bgColor?: string;
  horizontalAlign?: string;
  verticalAlign?: string;
  margin?: string;
  padding?: string;
  isMobile?: boolean;
}>`
  display: flex;
  flex-direction: column;
  padding: 16px;
  width: 100%;
  height: 100%;
  gap: 8px;
  ${(props) =>
    props.bgColor &&
    `
  background-color: ${props.bgColor};
`};
  ${(props) =>
    props.horizontalAlign &&
    `
  align-items: ${props.horizontalAlign};
`};
  ${(props) =>
    props.margin &&
    `
  margin: ${props.margin};
`};
  ${(props) =>
    props.padding &&
    `
  padding: ${props.padding};
`};
`;

export const HorizontalSubHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
  gap: 8px;
  width: 100%;
`;

export const PhotoInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const LoadDocumentsBox = styled.div<{ expandLoadDocumentButton?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 100%;
  min-height: 188px;
  gap: 24px;
  & button {
    max-width: ${({ expandLoadDocumentButton }) => (expandLoadDocumentButton ? '100%' : 'fit-content')};
    color: black;
  }
`;

export const LoadPhotosBoxButton = styled(AptunoButton)<{ isMobile?: boolean }>`
  ${({ isMobile }) => isMobile && 'max-width: 186px'};
  margin: auto;
`;

export const LoadPhotosContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 8px;
  margin-bottom: 24px;
  justify-content: center;
  gap: 8px;
  width: 100%;
  & button {
    max-width: 100%;
  }
`;

export const LoadedPhotosContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
`;

export const LoadPhotosButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 8px;
  height: 100%;
  width: 100%;
  & button {
    max-width: 100%;
  }
`;

export const NormalTextContainer = styled.div`
  width: 100%;
  color: black;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PhotoInfoSubtitleBlack = styled.a`
  color: black;
`;

export const PhotoInfoButton = styled(AptunoButton)<{ isMobile?: boolean }>`
  ${({ isMobile }) => !isMobile && 'margin-top: 2px'};
`;

export enum SubtitleWeightVariant {
  BOLD = 'bold',
  BOLDER = 'bolder',
}

export enum SubtitleColorVariant {
  GREY = 'grey',
  BLACK = 'black',
}

export const PhotoInfoSubtitle = styled.p<{
  margin?: string;
  align?: string;
  color?: SubtitleColorVariant;
  weight?: SubtitleWeightVariant;
}>`
  font-size: ${(props) => props.theme.typography.size.sm3}px;
  line-height: ${(props) => props.theme.typography.lineHeight.sm5}px;
  color: ${(props) => (props.color === SubtitleColorVariant.BLACK ? 'black' : props.theme.colors.textGray)};
  font-weight: ${(props) =>
    props.weight === SubtitleWeightVariant.BOLDER ? '700' : props.theme.typography.weight.bold};
  margin: 0;
  ${(props) => props.align && `text-align: ${props.align}`};
`;

export const Title = styled(BigTitle)<{ isMobile?: boolean }>`
  text-align: start;
  font-size: ${({ isMobile }) => (isMobile ? '22px' : '24px')};
  margin-bottom: 28px;
`;
export const TitleText = styled.h3`
  margin-left: 16px;
`;

export const IconClose = styled(Icon)`
  color: #9b9b9b;
  margin-right: 16px;
  cursor: pointer;
`;

export const TextNormal = styled.p<{ margin?: string; align?: string }>`
  font-size: ${(props) => props.theme.typography.size.sm2}px;
  line-height: ${(props) => props.theme.typography.lineHeight.sm5}px;
  color: ${(props) => props.theme.colors.textGray};
  font-weight: ${(props) => props.theme.typography.weight.regular};
  ${(props) =>
    props.margin &&
    `
    margin: ${props.margin}
  `};
  ${(props) => props.align && `text-align: ${props.align}`};
`;

export const ImgLoadedMiniPreview = styled.img`
  border-radius: 8px;
  height: 80px;
  width: 80px;
  object-fit: cover;
`;

export const UploadPictureButtonContainer = styled.div`
  width: 100%;
  & button {
    color: black !important;
  }
`;

export const FileTypeErrorModalFooterRoot = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  & button {
    min-width: 100%;
  }
`;

export const FileTypeErrorModalHeader = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: space-around;
  gap: 15px;
  z-index: 1;
  align-items: center;
  & > svg {
    color: #dee2e6;
    width: 30px;
    height: 30px;
  }
`;

export const FileTypeErrorModalTitle = styled.h1`
  font-style: normal;
  font-weight: 900;
  font-size: 22px;
  line-height: 30px;
  letter-spacing: -0.024em;
  color: #000000;
  margin: 0px;
`;
